/* THE FIELD POLICY, ASKED ONCE PER PAGE LOAD.
 *
 * ⚠️ NINE CORRECTABLE FIELDS MUST NOT BE NINE REQUESTS. The policy is a
 * statement about the CALLER, not about a record or a field — it is byte
 * identical for all of them — so one in-flight promise is shared by every
 * control on the page. `sharedCanvaStatus()` in the Artwork Studio exists for
 * exactly this reason: six pickers were each probing `/api/canva/status`, six
 * round trips that could disagree with each other.
 *
 * Disagreement is the real cost, not the traffic. Two controls in one drawer
 * resolving different policies would draw one field editable and an identical
 * one not.
 */
import { useEffect, useState } from 'react'
import {createSessionCache} from '../../../lib/sessionGeneration.js'
import {useSessionGeneration} from '../../../lib/useSessionGeneration.js'
import { loadFieldPolicy } from './fieldEditRun.js'
import { readFieldPolicy } from './fieldEdit.js'

const shared = createSessionCache()

/** Reset between sessions. Sign-out changes the caller, and the caller IS the
 *  policy — a cached exec policy surviving into a rep's session would draw
 *  privileged inputs that 403. */
export function resetFieldPolicy() {
  shared.clear()
}

export function sharedFieldPolicy() {
  return shared.load('championship', () => loadFieldPolicy()
    .then((res) => readFieldPolicy(res))
    .catch(() => readFieldPolicy(null)))
}

export function useFieldPolicy() {
  const [policy, setPolicy] = useState(null)
  const generation = useSessionGeneration()

  useEffect(() => {
    let alive = true
    setPolicy(null)
    sharedFieldPolicy().then((p) => { if (alive) setPolicy({value: p, generation}) }).catch(() => { if (alive) setPolicy(null) })
    return () => { alive = false }
  }, [generation])

  return policy?.generation === generation ? policy.value : null
}
